import { Backend } from '.';

/*

     unsubscribe_pwa_newsletter_subscriptions POST   /pwa/1/customer/newsletter_subscriptions/unsubscribe(.:format)          faceless/pwa/customer/newsletter_subscriptions#unsubscribe
                                              DELETE /pwa/1/customer/newsletter_subscriptions/token/:token(.:format)         faceless/pwa/customer/newsletter_subscriptions#destroy
                                              */

export async function unsubscribe(email: string) {
  return Backend.post<boolean>('/customer/newsletter_subscriptions/unsubscribe', {
    body: JSON.stringify({
      email,
    }),
  });
}

export async function delSubscription(confirmationToken: string) {
  return Backend.del<string>(`/customer/newsletter_subscriptions/token/${encodeURIComponent(confirmationToken)}`);
}

export default {
  unsubscribe,
  delSubscription,
};
